export const columnWidthVariable = (columnId: string): string =>
  `--column-${String(columnId).replace(/\s/g, '-')}-width`
